import { ButtonIcon } from 'components/Button';
import { Header } from 'components/Header';
import { Portal } from 'components/Portal';
import PropTypes from 'prop-types';
import Checkbox from 'rc-checkbox';
import 'rc-checkbox/assets/index.css';
import React, { useState } from 'react';
import '../style.scss';
import { TableProp, TableValueDynamic } from './TableItems';

const ModalCreateContact = ({ onSubmit, onClose }) => {
  const [values, setValues] = useState({
    name: '',
    phone: '',
    position: '',
    email: '',
    isMain: false,
  });
  const [errors, setErrors] = useState({});

  const handleSave = () => {
    const errors = {};
    if (!values.name) {
      errors.name = true;
    }

    if (!values.phone) {
      errors.phone = true;
    }

    if (Object.keys(errors).length > 0) {
      setErrors(errors);
      return;
    }

    onSubmit(values);
  };

  const handleValue = (key, value) => {
    if (errors[key]) {
      setErrors({ ...errors, [key]: false });
    }
    setValues({ ...values, [key]: value });
  };

  return (
    <Portal id="modal-create-client" className="modal-create-client contact" onClose={onClose}>
      <Header title="Новое контактное лицо" onClose={onClose}></Header>

      <div className="client-create-grid contact">
        <TableProp title="ФИО" icon="userverify" />
        <TableValueDynamic
          err={errors.name}
          value={values.name}
          onChange={(value) => handleValue('name', value)}
          placeholder="ФИО"
        />

        <TableProp title="Телефон осн." icon="phone" />
        <TableValueDynamic
          err={errors.phone}
          value={values.phone}
          onChange={(value) => handleValue('phone', value)}
          mask="+380 99 999 99 99"
          placeholder="+380 XX XXX XX XX"
        />

        <TableProp title="Должность" icon="chair" />
        <TableValueDynamic
          err={errors.position}
          value={values.position}
          onChange={(value) => handleValue('position', value)}
          placeholder="Должность"
        />

        <TableProp title="Эл. почта" icon="email" />
        <TableValueDynamic
          err={errors.email}
          value={values.email}
          onChange={(value) => handleValue('email', value)}
          placeholder="example@gmail.com"
        />

        <div></div>
        <label className="is-main">
          <Checkbox checked={values.isMain} onChange={(event) => handleValue('isMain', event.target.checked)} />-
          Основной
        </label>
      </div>

      <div className="buttons-block" style={{ margin: 0, marginBottom: 15 }}>
        <ButtonIcon className="btn-main btn-save" icon="save" onClick={handleSave} text="Сохранить" />
      </div>
    </Portal>
  );
};

ModalCreateContact.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export { ModalCreateContact };
